import React, { useState } from "react";
import Select from "react-select";
import Skeleton from "components/skeleton";
import GridListView from "./GridListView";
import { DateRangePicker } from "@ui";
import { findIcon } from "views/dashboard/icons";
import DownloadReport from "components/models/DownloadReport";
import * as authSelectors from "../../../../../store/auth/selectors";
import { useSelector } from "react-redux";

const ProjectFilters = ({
  title,
  setDateRangePayload,
  activeSummaryTab = {},
  isSummaryListLoading = false,
  projectStartDate = "",
  projectEndDate = "",
  showListView = false,
  showDatePicker = true,
  dateLabel,
  tabs = [],
  setActiveSummaryTab = () => {},
  ...props
}) => {
  const user = useSelector(authSelectors.user);
  const [showReportDownloadModal, setShowReportDownloadModal] = useState(false);

  const today = new Date();
  let endDateLimit = new Date(projectEndDate);

  const todayDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const endDateOnly = new Date(
    endDateLimit.getFullYear(),
    endDateLimit.getMonth(),
    endDateLimit.getDate()
  );

  if (endDateOnly.getTime() >= todayDate.getTime()) {
    endDateLimit = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1
    );
  }

  const formattedTabs =
    tabs?.map((tab) => {
      const content_title = tab?.fetch_with_image[0]?.content_title;
      const id = tab?.content_id;
      return {
        value: id,
        label: content_title,
      };
    }) || [];
  const handleChange = (event) => {
    setActiveSummaryTab(event);
  };
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "300px",
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: "0.5rem",
      borderColor: "#eee",
      boxShadow: "none",
      width: "100%",
      minHeight: "36px",
      height: "37px",
      "&:hover": {
        borderColor: "#e1e1e1",
      },
    }),
    menu: (provided) => ({
      ...provided,
      width: "100%",
    }),
    singleValue: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
    }),
    valueContainer: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
    placeholder: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
  };

  const customFilterOption = (option, searchText) => {
    const labelMatch = option.label
      .toLowerCase()
      .includes(searchText.toLowerCase());

    const valueMatch = option.value
      .toString()
      .toLowerCase()
      .includes(searchText.toLowerCase());
    return labelMatch || valueMatch;
  };

  const handleOpenModal = () => {
    setShowReportDownloadModal(true);
  };
  const handleCloseModal = () => {
    setShowReportDownloadModal(false);
  };
  const isUserHasDownloadReportPermission = user?.user_has_permissions?.some(
    (item) => item?.name === "view_inactive_project"
  );

  return (
    <>
      <div className="d-flex align-items-center flex-wrap gap-2 flex-shrink-0">
        {showListView && (
          <div>
            <GridListView
              isListView={props.isListView}
              setIsListView={props.setIsListView}
            />
          </div>
        )}
        {["Analytics", "Audience", "Location"].includes(title) ? (
          <Select
            options={formattedTabs}
            placeholder={activeSummaryTab?.label}
            name={activeSummaryTab?.label}
            isLoading={isSummaryListLoading}
            value={activeSummaryTab?.value}
            isSearchable
            onChange={handleChange}
            styles={customStyles}
            filterOption={customFilterOption}
          />
        ) : null}

        <div className="form-group mb-0 d-flex align-items-center justify-content-between">
          <div>
            {!isSummaryListLoading ? (
              showDatePicker && (
                <DateRangePicker
                  startDate={projectStartDate}
                  projectEndDate={projectEndDate}
                  endDate={endDateLimit}
                  setDateRangePayload={setDateRangePayload}
                  dateLabel={dateLabel}
                />
              )
            ) : (
              <Skeleton width={220} height={55} className="m-0" />
            )}
          </div>
        </div>

        {["Summary"].includes(title) && isUserHasDownloadReportPermission ? (
          <div>
            <button className="btn btn-success" onClick={handleOpenModal}>
              <span className="me-2">
                {findIcon("DownloadReport", "dual-tone", "18")}
              </span>
              Download Report
            </button>
          </div>
        ) : null}
      </div>

      <DownloadReport
        heading="Export Content Report"
        reportType="Contents"
        show={showReportDownloadModal}
        handleClose={handleCloseModal}
      />
    </>
  );
};

export default ProjectFilters;
